import moment from "moment";
import { Product } from "../interfaces";
import { capitalizeString } from "../shared/util";

export class ProductAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get name(){
        return capitalizeString(this.value.nme_producto_pd || '');
    }
    get contact_name(){
        return capitalizeString(this.value.contact_name || '');
    }

    get contact_email(){
        return capitalizeString(this.value.contact_email || '');
    }

    get group(){
        return capitalizeString( this.value?.group?.nme_grupo_gr || 'Sin grupo');
    }

    get university(){
        return capitalizeString( this.value?.university?.institution_name || 'Sin Institución');
    }

    get type(){
        return capitalizeString(this.value?.nme_tipologia_pd || '');
    }

    get created_at(){
        return moment(this.value.fcreacion_pd).format("YYYY-MM-DD");
    }

    get updated_at(){
        return moment(this.value.updated_at).format("YYYY-MM-DD");
    }

    adapt():Product {
        return {
            id: this.value?.id,
            key: this.value?.id,
            name: this.name,
            group: this.group || '',
            type: this.type || '',
            external_code : this.value.external_code,
            university : this.university,
            contact_name: this.contact_name,
            contact_email: this.contact_email,
            created_at: this.created_at,
            updated_at: this.updated_at
        }
    }
}